import Immutable from 'seamless-immutable'
import * as actions from './actions'

const initialState = Immutable.from({
  entry: {},
  loading: false,
  error: false,
})

const motorContentfulPage = (state = initialState, { type, payload, error }) => {
  switch (type) {
    case actions.RECEIVE_ENTRY:
      return state
        .set('entry', payload)
        .set('loading', false)
        .set('error', error)
    case actions.REQUEST_ENTRY:
      return state.set('loading', true).set('error', false)
    default:
      return state
  }
}

export default motorContentfulPage
